import { Utils } from '@viamap/viamap2-common';
import { UtmCoords } from './ObliqueFunc';
import { GenerateGeom } from './GenerateGeom';
import { MitLatLng } from './MapFacade';
import { SettingsManager } from '@viamap/viamap2-common';
import { FeatureLayer } from './WmsLayerFunc';
import { stringify as wktStringify } from 'wkt';
import { ESInterface } from 'src/compentsModus/ESInterface';
import { FilterType } from 'src/states/ExploreSearchState';
import { feature, featureCollection, polygon } from '@turf/helpers';
import { stringify } from 'wkt';
import { GenerateGeomUtils } from './GenerateGeomUtils';
import { WFStoGeoJson } from 'src/functions/WFSutils';
import { documentData } from 'src/components/DocumentsComponent';
import { DC } from 'src/dataCollector/DataCollector';
import { message } from 'src/components/Message';
import { SenestMarkerLagÅrstal } from 'src/components/MarkData';
import { WFSCollector } from 'src/dataCollector/WFSCollector';

type sendRequestType = {
   timeout?: number,
   path: string,
   method: string | "POST" | "GET",
   headers?: { [key: string]: string }
} & ({ hostname: string } | { host: string }) & ({ protocol: string } | { port: number })

const gSearchTypeArr = ['adresse', 'husnummer', 'kommune', 'matrikel', 'matrikel_udgaaet', 'navngivenvej', 'opstillingskreds', 'politikreds', 'postnummer', 'region', 'retskreds', 'sogn', 'stednavn'] as const;
type gsearchType = typeof gSearchTypeArr[number];

export class PropertyInfoInterface {
   static get API_KEY() {
      return SettingsManager.getSystemSetting("dllServicesKey");
   }

   static async sendRequest(options: sendRequestType, body?: any) {
      return new Promise((resolve, reject) => {
         let params = options;
         let url;
         if ("hostname" in params) {
            url = "https://" + params.hostname + params.path
         } else {
            url = "https://" + params.host + params.path
         }
         if (body) {
            params["body"] = JSON.stringify(body)
         }
         let timeout = options.timeout ?? 10000;
         const controller = new AbortController()
         setTimeout(() => controller.abort(), timeout)
         fetch(url, { ...params, signal: controller.signal }).then((a) => {
            if (a.headers['Content-Type']?.toLowerCase().startsWith("application/json")) {
               return a.json()
            }
            return a.json()
         }).then((result) => {
            resolve(result)
         }).catch((err) => {
            reject(err)
         })
      });
   }

   static async getMatrikelEjerlavkode(latlng: MitLatLng) {
      let utmCoords = GenerateGeom.convertFromLatLngToUTM(latlng);
      try {
         return await PropertyInfoInterface.getMatrikelData(utmCoords)
            .then(matrikelData => {
               let properties = matrikelData.features[0].properties;
               if (Object.keys(properties).length) {
                  return ({ ejerlavskode: properties.ejerlavskode, matrikelNr: properties.matrikelnummer });
               } else {
                  return ("No cadaster data for this point.");
               }
            })
      } catch {
         throw new Error("Could not retrieve cadaster data for this point");
      }
   }

   static async getEjendomStats(kommuneNr: string, postNr: string, kategori: number): Promise<any> {
      let serviceHost = SettingsManager.getSystemSetting("dllServicesUrl");
      let servicePath = "/getEjendomStats";

      let urlParams = {
         "kommuneNr": kommuneNr,
         "postNr": postNr,
         "kategori": kategori.toString()
      };
      const qstr = (new URLSearchParams(urlParams)).toString()
      let path = servicePath + "?" + qstr;
      let options = {
         hostname: serviceHost,
         protocol: "https:",
         // port: 443,
         path: path,
         method: 'GET',
         headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.API_KEY
         }
      };

      let res = await this.sendRequest(options);

      return res;
   }

   static async getHandelsOplysning(bfeNummer: string): Promise<any> {
      let serviceHost = SettingsManager.getSystemSetting("dllServicesUrl");
      let servicePath = "/getHandelsOplysning";

      let urlParams = {
         "BFEnr": bfeNummer
      };
      const qstr = (new URLSearchParams(urlParams)).toString()
      let path = servicePath + "?" + qstr;
      let options = {
         hostname: serviceHost,
         protocol: "https:",
         // port: 443,
         path: path,
         method: 'GET',
         headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.API_KEY
         }
      };

      let res = await this.sendRequest(options);

      return res;
   }


   static async getDataTingbog(ejerlavkode: string, matrikelnr: string): Promise<any> {
      let parameters = {
         "landsejerlavid": "" + ejerlavkode,
         "matrikelnr": matrikelnr
      };
      let serviceHost = SettingsManager.getSystemSetting("dllServicesUrl");
      let servicePath = "/getTinglysningsData";
      const options = {
         protocol: "https:",
         host: serviceHost,
         path: servicePath,
         method: "POST",
         headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.API_KEY
         }
      };

      let res = await this.sendRequest(options, parameters);

      return res;
   }

   static async getDataTingbogByBFE(BFEnr: string): Promise<any> {
      let parameters = {
         "BFEnr": "" + BFEnr
      };
      let serviceHost = SettingsManager.getSystemSetting("dllServicesUrl");
      let servicePath = "/getTinglysningsData";
      const options = {
         protocol: "https:",
         host: serviceHost,
         path: servicePath,
         method: "POST",
         headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.API_KEY
         }
      };

      let res = await this.sendRequest(options, parameters);

      return res;
   }

   static async Ejerlejligheder(SFEBFEnr: string | number) {
      let qs2 = {
         "SFEBFEnr": SFEBFEnr.toString(),
      };
      let urlParams = { ...qs2, ...this.getDatafordelerCredentials() };
      const qstr = (new URLSearchParams(urlParams)).toString()
      let path = "/Matriklen2/Matrikel/2.0.0/rest/Ejerlejlighed?" + qstr;
      let options = {
         hostname: 'services.datafordeler.dk',
         port: 443,
         path: path,
         method: 'GET',
      };

      let res = await this.sendRequest(options);

      return res;
   }

   static async EjerlejlighederEnkelt(ELBFEnr: string | number) {
      let qs2 = {
         "ELBFEnr": ELBFEnr.toString(),
      };
      let urlParams = { ...qs2, ...this.getDatafordelerCredentials() };
      const qstr = (new URLSearchParams(urlParams)).toString()
      let path = "/Matriklen2/Matrikel/2.0.0/rest/Ejerlejlighed?" + qstr;
      let options = {
         hostname: 'services.datafordeler.dk',
         port: 443,
         path: path,
         method: 'GET',
      };

      let res = await this.sendRequest(options);

      return res;
   }

   static async getMatrikelData(loc: UtmCoords) {
      const ftl = new FeatureLayer({
         "version": "1.1.1",
         "label": "t",
         "host": "services.datafordeler.dk",
         "path": "/MATRIKLEN2/MatGaeldendeOgForeloebigWMS/1.0.0/WMS",
         "layers": "Jordstykke_Gaeldende"
      })
      let { BBOX2, HEIGHT2, WIDTH2, X2, Y2 } = this.createSmallBox(loc);
      let URL = ftl.getinformationURL(BBOX2, HEIGHT2, WIDTH2, X2, Y2, {
         ...this.getDatafordelerCredentials(),
         "STYLES": "Jordstykke_Gaeldende_Roed",
         "FORMAT": "image/png",
         "INFO_FORMAT": "text/plain",
         "SRS": "EPSG:25832",
      });

      let res = await this.getFeatureInfo(URL);

      return res;
   }

   static async getJordbundsData(loc: UtmCoords) {
      const ftl = new FeatureLayer({
         "version": "1.3.0",
         "label": "t",
         "host": "geodata.fvm.dk",
         "path": "/geoserver/ows",
         "layers": "Jordbunds_og_terraenforhold:Jordbundskort_2019"
      })
      let { BBOX2, HEIGHT2, WIDTH2, X2, Y2 } = this.createSmallBox(loc);
      let URL = ftl.getinformationURL(BBOX2, HEIGHT2, WIDTH2, X2, Y2, {
         ...this.getDatafordelerCredentials(),
         "FORMAT": "image/png",
         "INFO_FORMAT": "text/plain",
         "SRS": "EPSG:25832",
         "QUERY_LAYERS": "Jordbunds_og_terraenforhold:Jordbundskort_2019",
         "CRS": "EPSG:25832"
      });

      let res = await this.getFeatureInfo(URL);

      return res;
   }

   static async getCVRData(cvrNr: number): Promise<any> {

      // var myHeaders = new Headers();
      // myHeaders.append("Authorization", "Basic bW9sYmFrLmRrX0NWUl9JX1NLWUVOOjE1NGVkNzMyLTMxNWEtNDk0NS05Mjc4LTY4ZWJhMTM2YzkwNw==");
      // myHeaders.append("Content-Type", "application/json");

      // var raw = JSON.stringify({
      //    "query": {
      //       "term": {
      //          "Vrvirksomhed.cvrNummer": cvrNr
      //       }
      //    }
      // });

      // var requestOptions = {
      //    method: 'POST',
      //    headers: myHeaders,
      //    body: raw,
      //    // redirect: 'follow'
      // };

      // fetch("http://distribution.virk.dk/cvr-permanent/virksomhed/_search", requestOptions)
      // .then(response => response.text())
      // .then(result => {
      //    console.log(result);
      //    resolve(result);
      //    }
      //    )
      // .catch(error => {
      //    console.log('error', error);
      //    reject(error);
      // });


      let serviceHost = SettingsManager.getSystemSetting("dllServicesUrl");
      let servicePath = "/getcvrdata";

      let parameters = {
         funktion: "hentElasticCVRNummer",
         id: cvrNr
      };

      let path = servicePath;
      let options = {
         protocol: "https:",
         hostname: serviceHost,
         // port: 443,
         path: path,
         method: 'POST',
         headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.API_KEY
         }
      };

      let res = await this.sendRequest(options, parameters);

      return res;

   }

   static async getLokalplanDataInsideGeom(layer: string, geom: any) {
      let wkt = wktStringify(geom.features[0])

      let parameters = {
         service: "wfs",
         request: "getFeature",
         version: "2.0.0",
         outputFormat: "json",
         crs: "EPSG:4326",
         typenames: layer,
         CQL_FILTER: `overlaps(geometri, ${wkt}) or within(geometri, ${wkt})`
      };
      let response = fetch("https://geoserver.plandata.dk/geoserver/wfs", {
         method: "POST",
         headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
         },
         body: (new URLSearchParams(parameters)).toString()
      });
      return await (await response).json();
   }

   // Should be called getOuterRing...
   static getCoords(geometry: any): (number[])[] {
      let result;
      switch (geometry.type) {

         case "MultiPolygon":
            result = geometry.coordinates[0][0];
            break;

         case "Polygon":
            result = geometry.coordinates[0];
            break;

         default:
            throw new Error("Unexpected coordinate type: " + geometry.type);
      }
      return result;
   }

   static setCoords(geometry: any, newCoords: (number[])[]): any {
      switch (geometry.type) {

         case "MultiPolygon":
            geometry.coordinates[0][0] = newCoords;
            break;

         case "Polygon":
            geometry.coordinates[0] = newCoords;
            break;

         default:
            throw new Error("Unexpected coordinate type: " + geometry.type);
      }
      return geometry;
   }


   static async getMarkData(geometry: any, year?: string): Promise<any> {
      return new Promise((resolve, reject) => {
         let layer = "Marker:Marker_" + SenestMarkerLagÅrstal;
         if (year !== undefined) {
            layer = `Marker:Marker_${year}`;
         }

         // convert geometry from WGS84 to UTM32 - to match the crs of the Marker layer
         // convert geometry from WGS84 to UTM32 - to match the crs of the Marker layer
         let transformedGeometry = GenerateGeomUtils.geoJsonCoordsTransformer<number>(geometry, (coord) => {
            let utm = GenerateGeomUtils.convertFromLatLngToUTM({ lat: coord[1], lng: coord[0] })
            return [utm.x, utm.y];
         })
         let wkt = stringify(transformedGeometry); let parameters = {
            service: "wfs",
            request: "getFeature",
            version: "1.1.0",
            outputFormat: "json",
            typenames: layer,
            // SRS:"EPSG:3857",
            // CRS:"EPSG:3857",
            format_options: "CHARSET:UTF-8",
            CQL_FILTER: `intersects(the_geom, ${wkt})`
         };
         fetch("https://geodata.fvm.dk/geoserver/ows", {
            method: "POST",
            headers: {
               "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
            },
            body: new URLSearchParams(parameters).toString()
         })
            .then(async (response) => {
               if (response.status == 200) {
                  // response is charset ISO-8859-1. Need to convert to utf-8;
                  const contentTypeStr = response.headers.get("Content-type");
                  let contentTypeList = contentTypeStr && contentTypeStr.split(";") || [];
                  let charset = contentTypeList?.find((a) => a.includes("charset"))?.split("=")?.[1] ?? "utf-8";
                  let Decoder = new TextDecoder(charset)
                  let decodedString = Decoder.decode(await response.arrayBuffer())
                  let json;
                  try {
                     json = JSON.parse(decodedString);
                  } catch (e) {
                     console.error(e);
                     reject(e);
                  }
                  // convert result from UTM32 to latlng
                  let transformedGeometry = GenerateGeomUtils.geoJsonCoordsTransformer<number>(json, (coord) => {
                     let utm = GenerateGeomUtils.convertFromUTMtoLatLng({ y: coord[1], x: coord[0] })
                     return [utm.lng, utm.lat];
                  })
                  return transformedGeometry;
               } else {
                  reject(response.statusText);
               }
            }).then((result) => {
               resolve(result)
            }).catch((err) => {
               reject(err)
            })
      });
   }

   /**
    * @deprecated use DC.WFS.getFeatureIntersect instead
    */
   static async getBeskyttetNatur(geometry: any): Promise<any> {
      let fx = featureCollection([feature(geometry)]);
      return DC.WFS.getFeatureIntersect("Miljø Portal", "2013 Beskyttede naturtyper", fx);
   }

   /**
    * @deprecated use DC.WFS.getFeatureIntersect instead
    */
   static async getBNBO(geometry: any): Promise<any> {
      let fx = featureCollection([feature(geometry)]);
      return DC.WFS.getFeatureIntersect("Miljø Portal", "2142 Kommunernes status for boringsnære beskyttelsesområder (BNBO)", fx);
   }

   static async getSFEFromPoint(point: { lat: number, lng: number }): Promise<any> {
      let coords = GenerateGeom.convertFromLatLngToUTM(point);
      let wkt = `POINT(${coords.x} ${coords.y})`;
      let parameters = new URLSearchParams({
         service: "wfs",
         request: "getFeature",
         version: "2.0.0",
         typename: "SamletFastEjendom_Gaeldende",
         CQL_FILTER: `intersects(geometri, ${wkt})`,
         srsName: "urn:ogc:def:crs:EPSG::4326",
         username: this.getDatafordelerCredentials().username,
         password: this.getDatafordelerCredentials().password
      });
      let data = await fetch("https://wfs.datafordeler.dk/MATRIKLEN2/MatGaeldendeOgForeloebigWFS/1.0.0/Wfs?" + parameters)
      let text = await data.text()
      let geojson = WFStoGeoJson(text).at(0)?.geoJson;
      if (geojson.features?.length > 0) {
         return geojson.features[0].properties;
      } else {
         throw new Error("No SFE found at this point");
      }
   }


   static async getMatrikelFromPoint(point: { lat, lng }): Promise<any> {
      let coords = GenerateGeom.convertFromLatLngToUTM(point);
      let wkt = `POINT(${coords.x} ${coords.y})`;
      let parameters = new URLSearchParams({
         service: "wfs",
         request: "getFeature",
         version: "2.0.0",
         typename: "Jordstykke_Gaeldende",
         CQL_FILTER: `intersects(geometri, ${wkt})`,
         srsName: "urn:ogc:def:crs:EPSG::4326",
         username: this.getDatafordelerCredentials().username,
         password: this.getDatafordelerCredentials().password
      });
      let data = await fetch("https://wfs.datafordeler.dk/MATRIKLEN2/MatGaeldendeOgForeloebigWFS/1.0.0/Wfs?" + parameters)
      let text = await data.text()
      let geojson = WFStoGeoJson(text).at(0)?.geoJson;
      console.log(geojson)
      return geojson;
   }

   /**
    * @deprecated
    */
   static async fetchMat2CadasterWFSForSFE(SFEBFEnr: number | string): Promise<any> {
      try {

         let matrikler = await WFSCollector.getFeatureQuery("Matriklen2", "Jordstykke_Gaeldende",
            `samletFastEjendomLokalId = '${SFEBFEnr}'`,
         )
         // Ejerlavsnavne er ikke retuneret fra WFS
         let EjerlavsNavne = {}
         let x = await DC.DF_GQL.Mat2.BestemtFastEjendom(SFEBFEnr.toString());
         const sfeNode = x.MAT_SamletFastEjendom?.nodes?.[0];
         if (sfeNode?.jordstykkeSamlesISamletFastEjendom?.nodes) {
            sfeNode.jordstykkeSamlesISamletFastEjendom.nodes.forEach((jordstykke) => {
               const ejerlav = jordstykke.jordstykkeLiggerIEjerlav;
               if (ejerlav?.ejerlavskode && ejerlav?.ejerlavsnavn) {
                  EjerlavsNavne = { ...EjerlavsNavne, [ejerlav.ejerlavskode]: ejerlav.ejerlavsnavn };
               }
            });
         }
         return featureCollection(matrikler.features.map((feature) => {
            let prop = feature.properties;
            return {
               ...feature,
               properties: {
                  Matrikelnummer: prop["matrikelnummer"],
                  Ejerlavskode: prop["ejerlavskode"],
                  Ejerlavsnavn: EjerlavsNavne[prop["ejerlavskode"]] || "unknown",
                  VejAreal: prop["vejareal"] || 0,
                  RegistreretAreal: prop["registreretAreal"] || 0,
                  SFEnummer: prop["samletFastEjendomLokalId"]
               }
            }
         }));
      } catch {
         return featureCollection([]);
      }
   }

   /**
    * @deprecated please use WFSCollector.getFeatureIntersect
    */
   static async fetchMat2CadasterWFSforPolygonFilterIntersectsPost(geometry: any): Promise<any> {
      const creds = this.getDatafordelerCredentials();
      let coords = PropertyInfoInterface.getCoords(geometry);
      let countCoords = coords.length;
      let posList = coords.reduce((result, lnglatArr, idx) => {
         return result + (idx > 0 ? ' ' : '') + lnglatArr[1] + ' ' + lnglatArr[0];
      }, "");
      const url = "https://wfs.datafordeler.dk/MATRIKLEN2/MatGaeldendeOgForeloebigWFS/1.0.0/Wfs?SERVICE=WFS";
      const credentials = `&username=${creds.username}&password=${creds.password}`;

      // virker. NB filter skal være GML version 3.x
      // <fes:Not xmlns:fes="http://www.opengis.net/fes/2.0">
      // </fes:Not>
      const xmlBody = `
<wfs:GetFeature xmlns:fes="http://www.opengis.org/fes/2.0" xmlns:wfs="http://www.opengis.net/wfs/2.0" xmlns:ows="http://www.opengis.net/ows/1.1" xmlns:gml="http://www.opengis.net/gml/3.2" xmlns:xlink="http://www.w3.org/1999/xlink" version="2.0.0">
<wfs:Query typeNames="Jordstykke_Gaeldende" srsName="urn:x-ogc:def:crs:EPSG:4326">
<fes:Filter>
<fes:Intersects>
<fes:ValueReference>geometry</fes:ValueReference>
<gml:Polygon srsName="urn:x-ogc:def:crs:EPSG:4326">
<gml:exterior>
<gml:LinearRing>
<gml:posList srsDimension="2" count="${countCoords}">${posList}</gml:posList>
</gml:LinearRing>
</gml:exterior>
</gml:Polygon>
</fes:Intersects>
</fes:Filter>
</wfs:Query>
</wfs:GetFeature>`;

      function getAllProperties(element: Element): any {
         let result: any = {};
         let allTags = Array.from(element.getElementsByTagName("*"));
         allTags.forEach((val) => {
            let tag = val.tagName;
            if (tag.startsWith("mat:")) {
               result[tag] = val.innerHTML;
            }
         });

         return result;
      }

      try {
         const response = await fetch(encodeURI(url + credentials), {
            method: "POST",
            body: xmlBody,
         })
            .catch((a) => { throw new Error(a) })
         let parser = new DOMParser();
         let doc = parser.parseFromString(await response.text(), "text/xml")
         let Polygons = Array.from(doc.getElementsByTagName("wfs:member"))?.map((member) => {
            let posLists = Array.from(member.getElementsByTagName("gml:posList"))?.map((a) => {
               const numList = a.innerHTML.split(" ").map((strVal) => { return Number.parseFloat(strVal) });
               let lng = numList.filter((a, index) => index % 2 == 0);
               let lat = numList.filter((a, index) => index % 2 == 1);
               return lat.map((a, b) => [a, lng[b]])
            })
            return polygon(posLists as any, getAllProperties(member));
         })
         return featureCollection(Polygons)
      } catch (e) {
         console.error(e)
         return featureCollection([])
      }
   }
   /*
       {
         "licenseFeature": "BackgroundLayerBeskyttetNatur",
         "label": "Fredskov",
         "group": "Beskyttet Natur & Grundvand",
         "host": "services.datafordeler.dk",
         "path": "/MATRIKLEN2/MatGaeldendeOgForeloebigWMS/1.0.0/WMS",
         "layers": "FredskovFlade_Gaeldende",
         "noLegend": false,
         "attrib": "Indeholder data fra Geodatastyrelsen",
         "propertiesToDisplay": [
           "forretningshaendelse",
           "forretningsproces",
           "id_lokalid",
           "virkningfra",
           "virkningsaktoer",
           "tematype"
         ],
         "translationTable": {
           "en": {
             "Fredskov": "Fredskov",
             "forretningshaendelse": "Forretningshændelse",
             "forretningsproces": "Forretningsproces",
             "id_lokalid": "Lokal id",
             "virkningfra": "Virkning fra",
             "virkningsaktoer": "Virkningsaktør",
             "tematype": "Tematype"
           },
           "da": {
             "Fredskov": "Fredskov",
             "forretningshaendelse": "Forretningshændelse",
             "forretningsproces": "Forretningsproces",
             "id_lokalid": "Lokal id",
             "virkningfra": "Virkning fra",
             "virkningsaktoer": "Virkningsaktør",
             "tematype": "Tematype"
           }
         },
         "urlParams": {
           "username": "QBXRBEJZGQ",
           "password": "Ballerup2100$"
         }
       },*/

   /**
    * @deprecated please use WFSCollector.getFeatureIntersect
    */
   static async fetchFredskovWFSforPolygonFilterIntersectsPost(geometry: any): Promise<any> {
      let fx = featureCollection([feature(geometry)]);
      return DC.WFS.getFeatureIntersect("Matriklen2", "FredskovFlade_Gaeldende", fx);
   }

   static async fetchMat2CadasterWFSforPolygon(geometry: any): Promise<any> {
      const creds = this.getDatafordelerCredentials();
      let coords = PropertyInfoInterface.getCoords(geometry);
      let countCoords = coords.length;
      let posList = coords.reduce((result, lnglatArr, idx) => {
         return result + (idx > 0 ? ' ' : '') + lnglatArr[1] + ' ' + lnglatArr[0];
      }, "");
      const url = "https://wfs.datafordeler.dk/MATRIKLEN2/MatGaeldendeOgForeloebigWFS/1.0.0/Wfs?SERVICE=WFS&REQUEST=GetFeature&VERSION=2.0.0&srsName=EPSG:4326&COUNT=500&TYPENAMES=Jordstykke_Gaeldende";
      const credentials = `&username=${creds.username}&password=${creds.password}`;

      // virker. NB filter skal være GML version 3.x
      const fesFilter = `&FILTER=<fes:Filter xmlns:fes="http://www.opengis.net/fes/2.0" xmlns:ogc="http://www.opengis.net/ogc" xmlns:gml="http://www.opengis.net/gml/3.2">
            <fes:Or xmlns:fes="http://www.opengis.net/fes/2.0">
               <fes:Overlaps>
                  <fes:ValueReference>geometry</fes:ValueReference>
                  <gml:Polygon srsName="urn:x-ogc:def:crs:EPSG:4326">
                     <gml:exterior>
                           <gml:LinearRing>
                              <gml:posList srsDimension="2" count="${countCoords}">${posList}</gml:posList>
                           </gml:LinearRing>
                     </gml:exterior>
                  </gml:Polygon>
               </fes:Overlaps>
               <fes:Or xmlns:fes="http://www.opengis.net/fes/2.0">
                  <fes:Within>
                     <fes:ValueReference>geometry</fes:ValueReference>
                     <gml:Polygon srsName="urn:x-ogc:def:crs:EPSG:4326">
                        <gml:exterior>
                              <gml:LinearRing>
                                 <gml:posList srsDimension="2" count="${countCoords}">${posList}</gml:posList>
                              </gml:LinearRing>
                        </gml:exterior>
                     </gml:Polygon>
                  </fes:Within>
                  <fes:Contains>
                     <fes:ValueReference>geometry</fes:ValueReference>
                     <gml:Polygon srsName="urn:x-ogc:def:crs:EPSG:4326">
                        <gml:exterior>
                              <gml:LinearRing>
                                 <gml:posList srsDimension="2" count="${countCoords}">${posList}</gml:posList>
                              </gml:LinearRing>
                        </gml:exterior>
                     </gml:Polygon>
                  </fes:Contains>
               </fes:Or>
            </fes:Or>
         </fes:Filter>`;

      function getAllProperties(element: Element): any {
         let result: any = {};
         let allTags = Array.from(element.getElementsByTagName("*"));
         allTags.forEach((val) => {
            let tag = val.tagName;
            if (tag.startsWith("mat:")) {
               result[tag] = val.innerHTML;
            }
         });

         return result;
      }

      try {
         const response = await fetch(encodeURI(url + credentials + fesFilter))
            .catch((a) => { throw new Error(a) })
         let parser = new DOMParser();
         let doc = parser.parseFromString(await response.text(), "text/xml")
         let Polygons = Array.from(doc.getElementsByTagName("wfs:member"))?.map((member) => {
            let posLists = Array.from(member.getElementsByTagName("gml:posList"))?.map((a) => {
               const numList = a.innerHTML.split(" ").map((strVal) => { return Number.parseFloat(strVal) });
               let lng = numList.filter((a, index) => index % 2 == 0);
               let lat = numList.filter((a, index) => index % 2 == 1);
               return lat.map((a, b) => [a, lng[b]])
            })
            return polygon(posLists as any, getAllProperties(member));
         })
         return featureCollection(Polygons)
      } catch (e) {
         console.error(e)
         return featureCollection([])
      }
   }

   static async fetchMat2CadasterWFSforPolygonPOST(geometry: any): Promise<any> {
      const creds = this.getDatafordelerCredentials();
      let coords = PropertyInfoInterface.getCoords(geometry);
      let countCoords = coords.length;
      let posList = coords.reduce((result, lnglatArr, idx) => {
         return result + (idx > 0 ? ' ' : '') + lnglatArr[1] + ' ' + lnglatArr[0];
      }, "");
      const url = "https://wfs.datafordeler.dk/MATRIKLEN2/MatGaeldendeOgForeloebigWFS/1.0.0/Wfs";
      const credentials = `?username=${creds.username}&password=${creds.password}`;

      // virker. NB filter skal være GML version 3.x
      const fesFilter = `<fes:Filter xmlns:fes="http://www.opengis.net/fes/2.0" xmlns:ogc="http://www.opengis.net/ogc" xmlns:gml="http://www.opengis.net/gml/3.2">
            <fes:Or xmlns:fes="http://www.opengis.net/fes/2.0">
               <fes:Overlaps>
                  <fes:ValueReference>geometry</fes:ValueReference>
                  <gml:Polygon srsName="urn:x-ogc:def:crs:EPSG:4326">
                     <gml:exterior>
                           <gml:LinearRing>
                              <gml:posList srsDimension="2" count="${countCoords}">${posList}</gml:posList>
                           </gml:LinearRing>
                     </gml:exterior>
                  </gml:Polygon>
               </fes:Overlaps>
               <fes:Or xmlns:fes="http://www.opengis.net/fes/2.0">
                  <fes:Within>
                     <fes:ValueReference>geometry</fes:ValueReference>
                     <gml:Polygon srsName="urn:x-ogc:def:crs:EPSG:4326">
                        <gml:exterior>
                              <gml:LinearRing>
                                 <gml:posList srsDimension="2" count="${countCoords}">${posList}</gml:posList>
                              </gml:LinearRing>
                        </gml:exterior>
                     </gml:Polygon>
                  </fes:Within>
                  <fes:Contains>
                     <fes:ValueReference>geometry</fes:ValueReference>
                     <gml:Polygon srsName="urn:x-ogc:def:crs:EPSG:4326">
                        <gml:exterior>
                              <gml:LinearRing>
                                 <gml:posList srsDimension="2" count="${countCoords}">${posList}</gml:posList>
                              </gml:LinearRing>
                        </gml:exterior>
                     </gml:Polygon>
                  </fes:Contains>
               </fes:Or>
            </fes:Or>
         </fes:Filter>`;

      let params = {
         "SERVICE": "WFS",
         "REQUEST": "GetFeature",
         "VERSION": "2.0.0",
         "srsName": "EPSG:4326",
         "COUNT": "500",
         "TYPENAMES": "Jordstykke_Gaeldende",
         // "username":creds.username,
         // "password":creds.password,
         "FILTER": fesFilter
      }

      function getAllProperties(element: Element): any {
         let result: any = {};
         let allTags = Array.from(element.getElementsByTagName("*"));
         allTags.forEach((val) => {
            let tag = val.tagName;
            if (tag.startsWith("mat:")) {
               result[tag] = val.innerHTML;
            }
         });

         return result;
      }

      try {
         const response = await fetch(url + credentials, {
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            method: 'POST',
            body: new URLSearchParams(params)
         })
            .catch((a) => { throw new Error(a) })
         let parser = new DOMParser();
         let doc = parser.parseFromString(await response.text(), "text/xml")
         let Polygons = Array.from(doc.getElementsByTagName("wfs:member"))?.map((member) => {
            let posLists = Array.from(member.getElementsByTagName("gml:posList"))?.map((a) => {
               const numList = a.innerHTML.split(" ").map((strVal) => { return Number.parseFloat(strVal) });
               let lng = numList.filter((a, index) => index % 2 == 0);
               let lat = numList.filter((a, index) => index % 2 == 1);
               return lat.map((a, b) => [a, lng[b]])
            })
            return polygon(posLists as any, getAllProperties(member));
         })
         return featureCollection(Polygons)
      } catch (e) {
         console.error(e)
         return featureCollection([])
      }
   }

   static getDatafordelerCredentials(): { username: string, password: string } {
      return {
         username: SettingsManager.getSystemSetting("datafordelerUsername"),
         password: SettingsManager.getSystemSetting("datafordelerPassword")
      };
   }

   /**
    * @link https://datafordeler.dk/dataoversigt/matriklen-mat/samlet-fast-ejendom/
    * @deprecated Use DataCollector.DF_GQL.Mat2.BestemtFastEjendom instead
    */
   // static async sfeLookupByBfeNr(bfeNr: number) {
   //    const { username, password } = this.getDatafordelerCredentials();
   //    return await fetch("https://services.datafordeler.dk/Matriklen2/Matrikel/1.0.0/REST/SamletFastEjendom?username=" + username + "&password=" + password +
   //       "&Format=JSON&SFEBFEnr=" + bfeNr);
   // }



   static async LookupByBFE(BFEnummer: number | string): Promise<BFEResult> {
      let qs2 = {
         "BFEnr": (typeof BFEnummer == "string" ? parseInt(BFEnummer) : Math.round(BFEnummer)).toString(),
         "format": "json"
      };
      let qs = { ...qs2, ...this.getDatafordelerCredentials() };
      const qstr = (new URLSearchParams(qs)).toString()
      const options = {
         hostname: 'services.datafordeler.dk',
         port: 443,
         method: 'GET',
         path: "/Matriklen2/Matrikel/2.0.0/REST/BestemtFastEjendom?" + qstr
      }
      let res = await this.sendRequest(options) as BFEResult;
      return res;
   }


   static async BBRejendomsrelationForBFE(BFEnr: string): Promise<any> {
      let qs2 = {
         "BFEnummer": BFEnr,
         "format": "json"
      };
      let qs = { ...qs2, ...this.getDatafordelerCredentials() };
      const qstr = (new URLSearchParams(qs)).toString()
      let path = "/BBR/BBRPublic/1/rest/ejendomsrelation?" + qstr;
      let options = {
         hostname: 'services.datafordeler.dk',
         port: 443,
         path: path,
         method: 'GET',
      };

      let res = await this.sendRequest(options);

      return res;
   }

   static async BBRbygningForGrundId(grundId: string): Promise<any> {
      let qs2 = {
         "grund": grundId,
         "format": "json"
      };
      let qs = { ...qs2, ...this.getDatafordelerCredentials() };
      const qstr = (new URLSearchParams(qs)).toString()
      let path = "/BBR/BBRPublic/1/rest/bygning?" + qstr;
      let options = {
         hostname: 'services.datafordeler.dk',
         port: 443,
         path: path,
         method: 'GET',
      };

      let res = await this.sendRequest(options);
      return res;
   }


   static async BBRTekniskAnlaeg<bbrValue extends string>(params: { [bbrKey: string]: bbrValue }) {
      const urlParams = {
         "format": "json",
         ...params,
         ...this.getDatafordelerCredentials()
      }

      let qstr = (new URLSearchParams(urlParams)).toString()
      let path = "/BBR/BBRPublic/1/rest/tekniskanlaeg?" + qstr;
      let options = {
         hostname: 'services.datafordeler.dk',
         path: path,
         port: 443,
         method: 'GET',
      };
      let res = await this.sendRequest(options);
      return res;
   }

   static async BBRteknikForGrundId(grundId: string): Promise<any> {
      let qs2 = {
         "grund": grundId,
      };
      return await PropertyInfoInterface.BBRTekniskAnlaeg(qs2);
   }

   static async BBRteknikForBFENR(bfeNr: string): Promise<any> {
      // Kun for BygningPåFremmedGrund og Ejerlejlighed
      let qs2 = {
         "BFENummer": bfeNr,
      };
      return await PropertyInfoInterface.BBRTekniskAnlaeg(qs2);
   }

   static async BBRteknikForBygId(bygId: string): Promise<any> {
      let qs2 = {
         "bygning": bygId,
      };
      return await PropertyInfoInterface.BBRTekniskAnlaeg(qs2);
   }

   static async BBRteknikForEnhedId(enhedId: string): Promise<any> {
      let qs2 = {
         "enhed": enhedId,
      };
      return await PropertyInfoInterface.BBRTekniskAnlaeg(qs2);
   }

   static async BBRenhedForEtageId(etageId: string): Promise<any> {
      let qs2 = {
         "etage": etageId,
      };
      return await PropertyInfoInterface.BBR_Datafordeler("enhed", qs2);
   }

   static async DAR_DatafordelerGaeldende(endpoint, query: { [key: string]: any }) {
      const params = new URLSearchParams({
         format: "json",
         status: "3",
         ...query,
         ...PropertyInfoInterface.getDatafordelerCredentials()
      }).toString();

      return await PropertyInfoInterface.sendRequest({
         hostname: 'services.datafordeler.dk',
         path: `/DAR/DAR/3.0.0/rest/${endpoint}?${params}`,
         port: 443,
         method: 'GET',
      });
   }


   static async BBR_Datafordeler(endpoint, query: { [key: string]: any }) {
      const params = new URLSearchParams({
         format: "json",
         ...query,
         ...PropertyInfoInterface.getDatafordelerCredentials()
      }).toString();

      return await PropertyInfoInterface.sendRequest({
         hostname: 'services.datafordeler.dk',
         path: `/BBR/BBRPublic/1/rest/${endpoint}?${params}`,
         port: 443,
         method: 'GET',
      });
   }

   static async BBREnhedForBFE(bfe_nr) {
      // Kun for Ejerlejligheds BFE_nr
      let qs2 = {
         BFENummer: bfe_nr
      }
      return await PropertyInfoInterface.BBR_Datafordeler("enhed", qs2)

   }

   static async BBRBygningForBFE(bfe_nr) {
      // Kun for BygningPåFremmedGrund og Ejerlejlighed bygning?
      let qs2 = {
         BFENummer: bfe_nr
      }
      return await PropertyInfoInterface.BBR_Datafordeler("bygning", qs2)

   }

   static async PEnhederpaaEjendom(matrikler: any[]): Promise<any> {
      let resMatrikler: any;

      resMatrikler = await Promise.all(matrikler.map(async (mat) => {
         let matrikelTekst = `${mat.matrikelnr} ${mat.ejerlavsnavn} (${mat.ejerlavkode})`;
         let adresseResponse = await DC.ADR.addresserPåJordstykke(mat.matrikelnr, mat.ejerlavkode);
         let adresser = adresseResponse?.husnumre?.flatMap(hus => hus.adresser ?? []).flat() ?? [];
         let resAdresser = await Promise.all(adresser.map(async (addr) => {
            let adresseTekst = addr.adressebetegnelse;
            let adresseId = addr.id;
            let pEnhederResponse = await this.getCVRSearch({
               "size": 20,
               "_source": [
                  "VrproduktionsEnhed.produktionsEnhedMetadata"
               ],
               "query": {
                  "term": {
                     "VrproduktionsEnhed.produktionsEnhedMetadata.nyesteBeliggenhedsadresse.adresseId.keyword": adresseId
                  }
               }
            }, "produktionsenhed");
            let pEnheder = pEnhederResponse?.hits?.hits;
            let res = pEnheder && pEnheder.reduce((result, pe) => {
               let item = pe._source.VrproduktionsEnhed.produktionsEnhedMetadata;
               if (item.sammensatStatus === "Aktiv") {
                  return [...result, {
                     navn: item.nyesteNavn.navn,
                     cvrNr: item.nyesteCvrNummerRelation,
                     branchetekst: item.nyesteHovedbranche.branchetekst,
                     branchekode: item.nyesteHovedbranche.branchekode,
                     kontaktoplysninger: item.nyesteKontaktoplysninger,
                     beskaeftigelseKvt: item.nyesteKvartalsbeskaeftigelse,
                     beskaeftigelseAar: item.nyesteAarsbeskaeftigelse
                  }]
               } else {
                  return result;
               }
            }, []);
            return {
               adresseData: { navn: adresseTekst, id: adresseId },
               pEnheder: res
            };
         }));
         return {
            matrikelData: { navn: matrikelTekst },
            adresser: resAdresser
         }
      })
      );

      // ToDo: Prune empty branches (not done above due to complexities with promises and 'reduce')

      return resMatrikler;
   }

   static async PEnhederforCVR(cvrNr: number): Promise<any> {

      let pEnhederResponse = await this.getCVRSearch({
         "size": 500,
         "_source": [
            "VrproduktionsEnhed.produktionsEnhedMetadata"
         ],
         "query": {
            "term": {
               "VrproduktionsEnhed.produktionsEnhedMetadata.nyesteCvrNummerRelation": cvrNr
            }
         }
      }, "produktionsenhed");
      let pEnheder = pEnhederResponse?.hits?.hits;
      let res = pEnheder && pEnheder.reduce((result, pe) => {
         let item = pe._source.VrproduktionsEnhed.produktionsEnhedMetadata;
         if (item.sammensatStatus === "Aktiv") {
            return [...result, {
               id: pe._id,
               navn: item.nyesteNavn.navn,
               cvrNr: item.nyesteCvrNummerRelation,
               branchetekst: item.nyesteHovedbranche.branchetekst,
               branchekode: item.nyesteHovedbranche.branchekode,
               kontaktoplysninger: item.nyesteKontaktoplysninger,
               beskaeftigelseKvt: item.nyesteKvartalsbeskaeftigelse,
               beskaeftigelseAar: item.nyesteAarsbeskaeftigelse,
               adresse: this.formatAddress(item.nyesteBeliggenhedsadresse)
            }]
         } else {
            return result;
         }
      }, []);
      return res;
   }

   static async CVRPersonDeltagerByEnhedsNummer(enhedsNummer: number): Promise<any> {
      let deltagerResponse = await this.getCVRSearch({
         "size": 10,
         "query": {
            "bool": {
               "must": [
                  {
                     "match": {
                        "Vrdeltagerperson.enhedstype": "PERSON"
                     }
                  },
                  {
                     "term": {
                        "Vrdeltagerperson.enhedsNummer": enhedsNummer
                     }
                  }
               ]
            }
         }
      }, "deltager");
      let deltagere = deltagerResponse?.hits?.hits;
      if (!deltagere || deltagere.length != 1) {
         throw new Error("Unexpected result count. 1 expected. Got: " + deltagere?.length);
      }
      let res = deltagere && deltagere.reduce((result, del) => {
         return del._source.Vrdeltagerperson;
      }, []);
      return res;
   }

   static async CVRPersonDeltagerByNameAndAddress(name: string, street: string, houseNo: number, zipCode: number, countryCode: string = "DK"): Promise<any> {
      let deltagerResponse = await this.getCVRSearch({
         "size": 10,
         "query": {
            "bool": {
               "must": [
                  {
                     "match": {
                        "Vrdeltagerperson.enhedstype": "PERSON"
                     }
                  },
                  {
                     "match_phrase": {
                        "Vrdeltagerperson.navne.navn": name
                     }
                  },
                  {
                     "match": {
                        "Vrdeltagerperson.deltagerpersonMetadata.nyesteBeliggenhedsadresse.vejnavn": street
                     }
                  },
                  {
                     "term": {
                        "Vrdeltagerperson.deltagerpersonMetadata.nyesteBeliggenhedsadresse.husnummerFra": houseNo
                     }
                  },
                  {
                     "term": {
                        "Vrdeltagerperson.deltagerpersonMetadata.nyesteBeliggenhedsadresse.postnummer": zipCode
                     }
                  },
                  {
                     "match": {
                        "Vrdeltagerperson.deltagerpersonMetadata.nyesteBeliggenhedsadresse.landekode": countryCode
                     }
                  }
               ],
               "must_not": [
                  {
                     "exists": {
                        "field": "Vrdeltagerperson.navne.periode.gyldigTil"
                     }
                  }
               ]
            }
         }
      }, "deltager");
      let deltagere = deltagerResponse?.hits?.hits;
      if (!deltagere || deltagere.length != 1) {
         console.error("Unexpected result count. 1 expected. Got: " + deltagere?.length);
         return [];
      }
      let res = deltagere && deltagere.reduce((result, del) => {
         return del._source.Vrdeltagerperson;
      }, []);
      return res;
   }

   /**
    * Returns all adresses for a property
    *
    * @param ejerlavkode
    * @param matrikelNr
    * @see https://docs.dataforsyningen.dk/#get__adresser
    * @returns
    */
   static async AdresserFraEjerlavOgMatrikel(ejerlavkode: number, matrikelNr: string): Promise<any> {
      let qs = {
         "ejerlavkode": ejerlavkode.toString(),
         "matrikelnr": matrikelNr,
         "status": (1).toString(), // gældende.
         "format": "json"
      };

      const qstr = (new URLSearchParams(qs)).toString()

      let path = "/adresser?" + qstr;
      let options = {
         hostname: 'api.dataforsyningen.dk',
         port: 443,
         path: path,
         method: 'GET',
      };

      let res = await this.sendRequest(options);

      return res;
   }

   private static createMatrikelGSearchUrl(ejerlavMatrikelSetObject: { ejerlavKode: number, matrikelNr: string }): string {
      const token = SettingsManager.getSystemSetting("dataforsyningenToken", "");
      let url = "https://api.dataforsyningen.dk/rest/gsearch/v2.0/matrikel?token=" + token +
         `&q=${ejerlavMatrikelSetObject.matrikelNr}` +
         `&limit=20` +
         `&filter=ejerlavskode='${ejerlavMatrikelSetObject.ejerlavKode}'`;
      return url;

   }

   static async getGeojsonOfCadasters(ejerlavMatrikelSetList: { ejerlavKode: number, matrikelNr: string }[]): Promise<any> {
      const gSearchUrlList = ejerlavMatrikelSetList.map(ejerlavMatrikelSet => this.createMatrikelGSearchUrl(ejerlavMatrikelSet));
      let gSearchResults = await Promise.all(gSearchUrlList.map(async gSearchUrl => {
         let tries = 3;
         while (tries > 0) {
            let resp = await fetch(gSearchUrl);
            if (resp.status === 200) {
               return resp.json();
            }
            await new Promise(aa => setTimeout(aa, 200));
            tries--;
         }
         throw new Error("Cound't get matrikel");
      }));

      const validResults = trimmedGSearchResult(gSearchResults)
      if (validResults.length) {
         return convertGsearchToGeoJson(validResults);
      } else {
         throw new Error("Invalid geosearch result");
      }


      function trimmedGSearchResult(gSearchResult: any): any[] {
         return gSearchResult.map((PossibleCadaster, idx) => {
            return (PossibleCadaster).find((SingleCadaster) => {
               return (ejerlavMatrikelSetList[idx].ejerlavKode.toString() === SingleCadaster.ejerlavskode.toString()
                  && ejerlavMatrikelSetList[idx].matrikelNr.toString() === SingleCadaster.matrikelnummer.toString());
            })
         }).filter(a => a)
      }

      function convertGsearchToGeoJson(gSearchResults: any[]) {
         let features = gSearchResults.map((feature) => {
            let geometry = feature.geometri.coordinates.map((poly) => {
               return poly.map(coordList => coordList.map(coord => GenerateGeom.convertFromUTMtoLatLng2(coord).reverse()))
            })
            return {
               "type": "Feature",
               "properties": {
                  "Matrikelnummer": feature.matrikelnummer,
                  "Ejerlavskode": feature.ejerlavskode,
                  "Ejerlavsnavn": feature.ejerlavsnavn,
               },
               "geometry": { ...feature.geometri, "coordinates": geometry }
            };
         });
         return {
            "type": "FeatureCollection",
            "features": features
         };;
      }
   }


   static async gSearch(type: gsearchType, queryString: string, limit?: number, filter?: string): Promise<any[]> {
      if (!(['adresse', 'husnummer', 'kommune', 'matrikel', 'matrikel_udgaaet', 'navngivenvej', 'opstillingskreds', 'politikreds', 'postnummer', 'region', 'retskreds', 'sogn', 'stednavn'].includes(type))) {
         throw new Error(`Unsupported gsearch type: ${type}`);
      }
      const token = SettingsManager.getSystemSetting("dataforsyningenToken", "");

      let qString = queryString.replace(/\s*,/, ",").replace(/^,\s?/, "")
      let gSearchUrl = `https://api.dataforsyningen.dk/rest/gsearch/v2.0/${type}?token=${token}&q=${qString}&srid=4326`;
      if (limit) {
         gSearchUrl += `&limit=${limit}`;
      }
      if (filter) {
         gSearchUrl += `&filter=${filter}`;
      }
      try {
         let resp = await fetch(gSearchUrl);
         if (resp.status === 200) {
            let json = await resp.json();
            return (json);
         } else {
            throw new Error(`Error getting adresses. Code ${resp.status}: ${resp.statusText}`);
         }
      } catch (err: any) {
         throw new Error(err?.msg ?? err)
      }
   }

   static async gSearchWithUTM32Filter(type: string, queryString: string, limit?: number, filter?: string): Promise<any[]> {
      if (!(['adresse', 'husnummer', 'kommune', 'matrikel', 'matrikel_udgaaet', 'navngivenvej', 'opstillingskreds', 'politikreds', 'postnummer', 'region', 'retskreds', 'sogn', 'stednavn'].includes(type))) {
         throw new Error(`Unsupported gsearch type: ${type}`);
      }
      const token = SettingsManager.getSystemSetting("dataforsyningenToken", "");

      let qString = queryString.replace(/\s*,/, ",").replace(/^,\s?/, "")
      let gSearchUrl = `https://api.dataforsyningen.dk/rest/gsearch/v2.0/${type}?token=${token}&q=${qString}&srid=25832`;
      if (limit) {
         gSearchUrl += `&limit=${limit}`;
      }
      if (filter) {
         gSearchUrl += `&filter=${filter}`;
      }
      try {
         let resp = await fetch(gSearchUrl);
         if (resp.status === 200) {
            let json = await resp.json();
            // konverter til LatLng
            json = json.map((hit) => {
               hit.geometri = GenerateGeomUtils.geoJsonCoordsTransformer(hit.geometri, (coord) => {
                  let latLng = GenerateGeomUtils.convertFromUTMtoLatLng2(coord as [number, number]).toReversed();
                  return latLng as [number, number];
               });
               return hit;
            })
            return (json);
         } else {
            throw new Error(`Error getting adresses. Code ${resp.status}: ${resp.statusText}`);
         }
      } catch (err: any) {
         throw new Error(err?.msg ?? err)
      }
   }


   static async getGeojsonOfSFE(bfeNr: number) {
      return await PropertyInfoInterface.fetchMat2CadasterWFSForSFE(bfeNr);
   }

   static async getGeojsonOfVurd(bfeNr: number): Promise<any> {
      message.info("Afventer moderniserede services, funktion virker ikke pt")
      return this.getGeojsonOfSFE(bfeNr) as any;
      // const ejendomsVurderingList = await this.vurdLookupByBfeNr(bfeNr.toString());

      // if (ejendomsVurderingList.length) {
      //    const latestEjendomsVurdering = ejendomsVurderingList.reduce((prev, current) => (prev.år > current.år) ? prev : current);
      //    return getGeojsonOfSeveralSFE(latestEjendomsVurdering.BFEnummerList);
      // } else {
      //    return this.getGeojsonOfSFE(bfeNr);
      // }


      // async function getGeojsonOfSeveralSFE(bfeNrList: number[]) {
      //    let geojson = {
      //       features: []
      //    };
      //    await Promise.all(bfeNrList.map(async bfeNummer => {
      //       return PropertyInfoInterface.getGeojsonOfSFE(bfeNummer)
      //          .then(geojsonResult => {
      //             geojson.features = geojson.features.concat(geojsonResult.features);
      //          });
      //    }));
      //    return geojson;
      // }
   }

   /**
 * Henter en liste over alle matrikler (max 1000) for det givne ejerlav ved opslag i søgedatabasen
 * @param ejerlavkode Ejerlavskode
 * @param matrikelNr Evt. matrikel nummer for at indsnævre resultater
 * @returns Liste af matrikelinformation
 * @documentation https://dawadocs.dataforsyningen.dk/dok/api/BBR%20matrikelreference#s%C3%B8gning
 */
   static async getMatrikelListe(ejerlavkode: string | number): Promise<any> {
      let index = SettingsManager.getSystemSetting("indexNamePropertySearch");
      let es = new ESInterface(index);
      let res = await es.doQuery({
         "_source": [
            "jords_matrikelnr",
            "jords_ejerlavskode"
         ],
         "query": {
            "match_phrase": {
               "jords_ejerlavskode": "" + ejerlavkode
            }
         },
         size: 1000
      });
      let hits = res?.hits?.hits;
      let res2 = hits?.map((r) => {
         return {
            MatrNr: r._source.jords_matrikelnr,
            LandsejerlavKode: r._source.jords_ejerlavskode
         }
      });
      return res2;
   }

   /**
    * Henter en liste over matrikler med et bestemt prefix for det givne ejerlav.
    * @param ejerlavkode Ejerlavskode
    * @param matrikelNr Matrikel nummer prefix for at indsnævre resultater
    * @returns Liste af matrikelinformation
    */
   static async getMatrikelListeByPrefix(ejerlavkode: number, matrikelNrPrefix: string): Promise<any> {
      let url = this.createMatrikelGSearchUrl({ ejerlavKode: ejerlavkode, matrikelNr: matrikelNrPrefix })

      return await fetch(url).then(
         async result => {
            let json = await result.json();
            return json;
         }
      );
   }

   static async getFeatureInfo(url: string) {
      let query = url;
      try {
         let result;
         const response: Response = await fetch(query, {
            mode: "cors", // no-cors, cors, *same-origin
            headers: {
            },
         });
         const resultCode = await response.status;
         if (resultCode === 200) {
            // If needed convert data to json structure.
            const contentTypeStr = response.headers.get("Content-type");
            let contentTypeList = contentTypeStr && contentTypeStr.split(";");
            let contentType = contentTypeList && contentTypeList.length > 0 && contentTypeList[0];
            switch (contentType) {
               case 'text/xml':
                  // oxlint-disable-next-line no-unused-vars
                  let xml = await response.text();
                  let jsonStr = "{}" //TODO:Fix XMLJS.xml2json(xml, {compact: true, spaces: 4});
                  let json = JSON.parse(jsonStr);
                  let attrs = json.FeatureInfoResponse && json.FeatureInfoResponse.FIELDS && json.FeatureInfoResponse.FIELDS._attributes;
                  result = { "features": [{ "properties": attrs }] };
                  break;
               case 'text/plain':
                  // Todo: tris works for matrikelkort. Need to be changed for other map types returning text.
                  let text = await response.text();
                  let lines = text.split(/\r?\n/);
                  let attrs2 = {};
                  lines.forEach(line => {
                     if (line.includes("=")) {
                        let parts = line.split("=");
                        let key = parts[0].trim();
                        // Strings are quoted with '. For presentation remove ' from strings
                        let val = parts[1] && parts[1].trim().split("'").join("");
                        attrs2[key] = val;
                     }
                  });
                  result = { "features": [{ "properties": attrs2 }] };
                  break;
               case 'application/json':
                  result = await response.json();
                  break;
               default:
                  // oxlint-disable-next-line no-unused-vars
                  let text2 = await response.text();
                  throw Utils.createErrorEventObject("unexpected: " + contentTypeStr);
            }
         } else {
            throw Utils.createErrorEventObject("result code: " + resultCode);
         }
         return result;
      } catch (err: any) {
         throw Utils.createErrorEventObject("MapScreen getFeatureInfo. Error" + err);
      }
   }

   static async ejerAfEjerlejlighed(bfeNummer: number | string) {
      let elasticIndex = SettingsManager.getSystemSetting("indexNamePropertySearch");
      let ifx = new ESInterface(elasticIndex);

      try {
         return await ifx.doSearch({ "bfe_nr": { title: "BFEnr", filterType: FilterType.String, default: ["6"], translationTable: {} } }, { "bfe_nr": [bfeNummer.toString()] }, 1)
            || undefined
      } catch (err) {
         console.error("PropertyInfoInterfaces", "ejerAfEjerlejlighed", err)
         return undefined
      }
   }

   static async getPropertiesOwnedByPerson(name: string, zipCode: number, address: string): Promise<any> {

      let elasticIndex = SettingsManager.getSystemSetting("indexNamePropertySearch");

      let ifx = new ESInterface(elasticIndex);
      return ifx.doQuery({
         "size": 1000,
         "query": {
            "bool": {
               "must": [
                  {
                     "nested": {
                        "path": "ejf_ejere_liste",
                        "query": {
                           "bool": {
                              "must": [
                                 {
                                    "match_phrase": {
                                       "ejf_ejere_liste.navn": name
                                    }
                                 },
                                 {
                                    "term": {
                                       "ejf_ejere_liste.postnr": zipCode
                                    }
                                 },
                                 {
                                    "term": {
                                       "ejf_ejere_liste.adresse.keyword": address
                                    }
                                 }
                              ]
                           }
                        }
                     }
                  }
               ]
            }
         }

      });

   }

   private static createSmallBox(loc: UtmCoords) {
      // create a small box around the point (as required by service)
      let offset = 1; // meters (UTM32)
      let sw = { x: loc.x - offset, y: loc.y - offset };
      let ne = { x: loc.x + offset, y: loc.y + offset };
      let BBOX2 = sw.x + "," + sw.y + "," + ne.x + "," + ne.y;
      let WIDTH2 = 1000;
      let HEIGHT2 = 1000;
      let X2 = 500;
      let Y2 = 500;
      return { BBOX2, HEIGHT2, WIDTH2, X2, Y2 };
   }


   static async getCVRSearch(query: any, index: string = "virksomhed"): Promise<any> {

      let serviceHost = SettingsManager.getSystemSetting("dllServicesUrl"); // Utils.getSystemSettingByEnvironment("obliqueServiceHost");
      let servicePath = "/getcvrdata";

      let parameters = {
         funktion: "hentQuery",
         "query": { ...query, size: 100 },
         "index": index
      };

      let path = servicePath;
      let options = {
         protocol: "https:",
         hostname: serviceHost,
         path: path,
         method: 'POST',
         headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.API_KEY
         }
      };

      let res = await this.sendRequest(options, parameters);

      return res;

   }



   public static extractRelevantData(rawCVRREturn: any): any {
      function getActiveRecord(recs: { periode: { gyldigFra: string, gyldigTil: string }, navn: string }[]): any {
         let active = recs.find((r) => r.periode.gyldigTil === null)
         if (active) {
            return active
         }
         let lastActive = recs.toSorted((a, b) => a.periode.gyldigTil > b.periode.gyldigTil ? -1 : 1)[0]
         if (lastActive.navn) {
            lastActive.navn = "❗" + lastActive.navn
            return lastActive
         }
         return null
      }

      if (rawCVRREturn.hits) {
         if (rawCVRREturn.hits.total !== 1) {
            return { message: "Unexpected hit count: " + rawCVRREturn.hits }
         } else {
            let virk = rawCVRREturn.hits.hits[0]._source.Vrvirksomhed;

            let deltagereEjereOrg = (virk.deltagerRelation as any[]).reduce<any[]>((prev, delt) => {
               let ejerOrganisationer = (delt.organisationer as any[]).filter((deltorg) => {
                  if (deltorg.hovedtype === "FULDT_ANSVARLIG_DELTAGERE") {
                     let navn = getActiveRecord(deltorg.medlemsData?.[0]?.attributter?.[0]?.vaerdier)?.vaerdi
                     let res = navn === "INTERESSENTER";
                     res ??= getActiveRecord(deltorg.organisationsNavn)?.navn;
                     return res;
                  }
                  if (deltorg.hovedtype === "REGISTER") {
                     let navn = getActiveRecord(deltorg.organisationsNavn).navn;
                     let res = navn === "EJERREGISTER";
                     return res;
                  } else {
                     return false;
                  }
               });
               if (ejerOrganisationer.length === 1) {
                  prev.push({ deltager: delt.deltager, ejerOrg: ejerOrganisationer[0] });
               } else {
                  if (ejerOrganisationer.length > 1) {
                     prev.push({ deltager: delt.deltager, ejerOrg: ejerOrganisationer[0] });
                     console.warn("Multiple ejerOrganisationer uses first:", delt.deltager);
                     // throw new Error("Unexpected orgs count: " + ejerOrganisationer.length);
                  }
               }
               return prev;
            }, []);
            let attributter = (virk.attributter as any[]).map((att) => {
               let vrec = getActiveRecord(att.vaerdier);
               return {
                  "type": att.type,
                  "vaerditype": att.vaerditype,
                  "vaerdi": vrec && vrec.vaerdi || "NOV"
               }
            })
            return {
               "cvrNummer": virk.cvrNummer,
               "navn": getActiveRecord(virk.navne).navn,
               "branchekode": getActiveRecord(virk.hovedbranche)?.branchekode,
               "branchetekst": getActiveRecord(virk.hovedbranche)?.branchetekst,
               "attributter": attributter,
               "ejere": deltagereEjereOrg.reduce((prev, { deltager, ejerOrg }) => {
                  let ejer = deltager;
                  // find ejeranddel
                  let andelAtt = ejerOrg.medlemsData && ejerOrg.medlemsData[0].attributter.filter((att: any) => att.type === "EJERANDEL_PROCENT");
                  let andelV = andelAtt?.length && getActiveRecord(andelAtt[0].vaerdier);
                  const fuldAnsvar = ejerOrg.hovedtype === "FULDT_ANSVARLIG_DELTAGERE";
                  let andelVaerdi = (andelV && andelV.vaerdi) || (fuldAnsvar && 1) || "NOTF";

                  if (andelVaerdi !== "NOTF") {
                     // konverter til andel til procent.
                     andelVaerdi *= 100;
                     return [...prev, {
                        "enhedstype": ejer.enhedstype,
                        "forretningsnoegle": ejer.forretningsnoegle,
                        "cvrPersonId": ejer.enhedsNummer,
                        "navn": getActiveRecord(ejer.navne).navn,
                        "andel": andelVaerdi
                     }]
                  } else {
                     return prev;
                  }
               }, [])
            }
         }
      } else {
         return { message: "Unexpected record format" }
      }
   }

   static formatAddress(beliggenhedsAdresse: any): string {
      function nvl(value: any): string {
         return value ? value : "";
      }
      let ba = beliggenhedsAdresse;
      let result = "";

      if (ba.conavn) {
         result += "c/o " + ba.conavn + "; ";
      }
      if (ba.vejnavn) {
         result += ba.vejnavn + " ";
      }
      let nummer = nvl(ba.husnummerFra) + nvl(ba.bogstavFra) + (ba.husnummerTil ? "-" + nvl(ba.husnummerTil) + nvl(ba.bogstavTil) : "");
      let etage = ba.etage ? " " + ba.etage + "." : "";
      let side = ba.sidedoer ? " " + ba.sidedoer : "";
      if (nummer && nummer.length > 0) {
         result += nummer + etage + side;
      }
      let postboks = ba.postboks ? " " + ba.postboks + ", " : "";
      let landekode = ba.landekode ? " " + ba.landekode + (ba.postnummer ? "-" : "") : "";
      result += `${postboks}${landekode}${nvl(ba.postnummer)} ${nvl(ba.postdistrikt)}`;

      return result;
   }

   static getEmoDataCredentials(): { username: string, password: string } {
      return {
         username: SettingsManager.getSystemSetting("emodataUsername"),
         password: SettingsManager.getSystemSetting("emodataPassword")
      };
   }

   /**
    * Fetch energy label data for a BFE number
    * @param bfeNumber - The BFE number to search for
    * @returns Promise with energy label data
    */
   static async getEnergyLabelData(bfeNumber: number): Promise<any> {
      try {
         const { username, password } = this.getEmoDataCredentials();
         const url = `https://emoWeb.dk/EMOData/EMOData.svc/SearchEnergyLabelBFE/${bfeNumber}`;

         let serviceHost = SettingsManager.getSystemSetting("mapitServicesHost") || "unknown";
         let proxyQuery = `https://${serviceHost}/${SettingsManager.getSystemSetting("mapitGeoserverProxyResourceName", "geoserverproxy")}`;

         const response = await fetch(proxyQuery, {
            method: "post",
            mode: "cors",
            headers: {
               "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
               "X-API-KEY": SettingsManager.getSystemSetting("mapitServicesAPIKey")
            },
            body: JSON.stringify({
               "url": url,
               "options": {
                  "headers": {
                     "Authorization": `Basic ${btoa(username + ':' + password)}`,
                     "Content-Type": "application/json"
                  }
               }
            })
         });

         if (!response.ok) {
            return null; // Return null instead of throwing
         }

         const responseData = await response.json();

         if (responseData.statusCode === 200 && responseData.body) {
            const parsedBody = JSON.parse(responseData.body);

            // Check if we have energy labels
            if (parsedBody.EnergyLabels && parsedBody.EnergyLabels.length > 0) {
               return {
                  EnergyLabels: parsedBody.EnergyLabels,
                  ResponseStatus: parsedBody.ResponseStatus
               };
            }
         }

         return null; // No data found
      } catch (error) {
         console.error('Error fetching energy label data:', error);
         return null; // Return null on any error
      }
   }

   /**
    * Fetch energy label PDF document
    * @param identifier - The EnergyLabelSerialIdentifier
    * @returns Promise with PDF blob
    */
   static async getEnergyLabelPdf(identifier: string): Promise<Blob | null> {
      try {
         const { username, password } = this.getEmoDataCredentials();
         const url = `https://emoWeb.dk/EMOData/EMOData.svc/FetchEnergyLabelPdf/${identifier}`;

         let serviceHost = SettingsManager.getSystemSetting("mapitServicesHost") || "unknown";
         let proxyQuery = `https://${serviceHost}/${SettingsManager.getSystemSetting("mapitGeoserverProxyResourceName", "geoserverproxy")}`;

         const response = await fetch(proxyQuery, {
            method: "post",
            mode: "cors",
            headers: {
               "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
               "X-API-KEY": SettingsManager.getSystemSetting("mapitServicesAPIKey")
            },
            body: JSON.stringify({
               "url": url,
               "options": {
                  "headers": {
                     "Authorization": `Basic ${btoa(username + ':' + password)}`,
                     "Content-Type": "application/json"
                  }
               }
            })
         });

         if (!response.ok) {
            return null;
         }

         const result = await response.json();
         const responseData = JSON.parse(result.body);

         // Check if PDF exists
         if (!responseData.PdfDocument || responseData.PdfDocument === "") {
            return null;
         }

         // Decode the base64 PDF data
         const pdfBase64 = responseData.PdfDocument;
         const binaryString = atob(pdfBase64);
         const bytes = new Uint8Array(binaryString.length);

         for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
         }

         return new Blob([bytes], { type: 'application/pdf' });
      } catch (error) {
         console.error('Error fetching energy label PDF:', error);
         return null;
      }
   }

   /**
    * Fetch PDF documents using proxy (generic method)
    * @returns Promise with PDF blob
    */
   static async fetchViaProxy(doc: documentData) {

      // Special handling for BBR Meddelelse PDF: try GET via proxy with browser headers
      const serviceHost = SettingsManager.getSystemSetting("mapitServicesHost") || "unknown";
      const proxyQuery = `https://${serviceHost}/${SettingsManager.getSystemSetting("mapitGeoserverProxyResourceName", "geoserverproxy")}`;
      if (doc.useProxy) {
         // Use POST to proxy. Ensure we send the actual URL string (call getUrl if it's a function).
         const targetUrl = (typeof doc.getUrl === 'function') ? doc.getUrl() : doc.getUrl;
         const response = await fetch(proxyQuery, {
            method: "POST",
            mode: "cors",
            headers: {
               "X-API-KEY": SettingsManager.getSystemSetting("mapitServicesAPIKey"),
               "Content-Type": "application/json"
            },
            body: JSON.stringify({
               "url": targetUrl,
               "direct": true,
               "options": {
                  "headers": {
                  }
               }
            })
         });
         if (!response.ok) {
            // Return null so callers can mark a download error instead of throwing
            console.warn(`[PropertyInfoInterface] Proxy fetch failed (${response.status}) for ${targetUrl}`);
            return null;
         }

         // If the proxy returned a JSON wrapper (common behavior), try to extract a base64 body
         const contentType = (response.headers.get('content-type') || '').toLowerCase();
         if (contentType.includes('application/json')) {
            const json = await response.json();
            // Many proxies return { statusCode, body } where body may be base64 encoded binary
            if (json && typeof json.body === 'string') {
               const maybeB64 = json.body;
               // Heuristic: if the body looks like base64 try to decode to binary
               try {
                  const binary = atob(maybeB64);
                  const arr = new Uint8Array(binary.length);
                  for (let i = 0; i < binary.length; i++) arr[i] = binary.charCodeAt(i);
                  const mime = doc.returnDoc === 'png' ? 'image/png' : (doc.returnDoc === 'pdf' ? 'application/pdf' : 'application/octet-stream');
                  return new Blob([arr], { type: mime });
               } catch {
                  // Not base64 — return the raw json.body as text blob
                  return new Blob([json.body], { type: 'text/plain' });
               }
            }
            // If no body field, return the full JSON as blob
            return new Blob([JSON.stringify(json)], { type: 'application/json' });
         }

         // Otherwise return the response as a Blob directly (binary proxy passthrough)
         return await response.blob();
      }
   }
}

type DataCollection<data> = { type: "FeatureCollection", features: data[] }
type BFEResult = {
   SamletFastEjendom: DataCollection<any>
   Ejerlejlighed: DataCollection<any>
   BygningPaaFremmedGrund: {
      BygningPaaFremmedGrundFlade: DataCollection<any>
      BygningPaaFremmedGrundPunkt: DataCollection<any>
   }
}
